import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const SystemRouter: Array<RouteRecordRaw> = [
  {
    path: '/system',
    component: Layout,
    redirect: '/department/list',
    meta: {
      title: 'system',
      icon: '#iconexample',
      alwaysShow: true
    },
    children: [
      {
        path: 'department/list',
        component: () => import(/* webpackChunkName: "department-list" */ '@/views/system/department/Index.vue'),
        name: 'departmentList',
        meta: {
          title: 'department',
          icon: 'list'
        }
      },
      {
        path: 'role/list',
        component: () => import(/* webpackChunkName: "role-list" */ '@/views/system/role/Index.vue'),
        name: 'roleList',
        meta: {
          title: 'role',
          icon: 'list'
        }
      },
      {
        path: 'menu/list',
        component: () => import(/* webpackChunkName: "menu-list" */ '@/views/system/menu/Index.vue'),
        name: 'menuList',
        meta: {
          title: 'menu',
          icon: 'list'
        }
      },
      {
        path: 'user/list',
        component: () => import(/* webpackChunkName: "user-list" */ '@/views/system/user/Index.vue'),
        name: 'userList',
        meta: {
          title: 'user',
          icon: 'list'
        }
      }
    ]
  },
  {
    path: '/dictionary',
    component: Layout,
    redirect: '/dictionary/list',
    meta: {
      title: 'dictionary',
      icon: '#iconexample',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "user-list" */ '@/views/dictionary/commission/Index.vue'),
        name: 'commissionList',
        meta: {
          title: 'commissionList',
          icon: 'list'
        }
      }
    ]
  }
]

export default SystemRouter
